import { API } from '@/services/api/internal/tools/baseAPI';

interface BaseServiceOpts<S> {
  readonly urlParamsCurrent?: any;
  readonly urlParamsItems?: any;
  readonly api?: any;
  readonly retry?: any;
  treatListResponse?: (response) => S[];
  treatCurrentResponse?: (response) => S;
  treatCreateResponse?: (response) => S;
}

export interface Service<S> {
  api: API<S>;
  getItems(config, variableUrl): Promise<S[]>;
  getCurrent(id: number): Promise<S>;
  createItem(item: S, variableUrl?: string);
  updateItem(item: S, variableUrl?: string);
  deleteItem(id: number, variableUrl?: string);
}

export default class BaseService implements Service<any> {
  api: API<any>;

  private readonly treatCurrentResponse: (response) => any;

  private readonly treatListResponse: (response) => any[];

  private readonly treatCreateResponse: (response) => any;

  private retry: any;

  private urlParamsItems: any;

  private urlParamsCurrent: any;

  constructor({
    api,
    urlParamsCurrent,
    urlParamsItems,
    retry,
    treatListResponse = (response) => response.data.items,
    treatCurrentResponse = (response) => response.data,
    treatCreateResponse = (response) => response.data,
  }: BaseServiceOpts<any>) {
    this.api = api;
    this.treatListResponse = treatListResponse;
    this.treatCurrentResponse = treatCurrentResponse;
    this.treatCreateResponse = treatCreateResponse;
    this.retry = retry;
    this.urlParamsItems = urlParamsItems;
    this.urlParamsCurrent = urlParamsCurrent;
  }

  getItems = (
    config = {
      params: undefined,
    },
    variableUrl
  ) =>
    this.api
      .getItems(
        {
          ...config,
          __retry: this.retry,
          params: {
            ...config.params,
            ...this.urlParamsItems,
          },
        },
        variableUrl
      )
      .then(this.treatListResponse);

  getCurrent = (id) =>
    this.api
      .getCurrent(id, {
        __retry: this.retry,
        params: {
          ...this.urlParamsCurrent,
        },
      })
      .then(this.treatCurrentResponse);

  createItem = (item, variableUrl) =>
    this.api.createItem(item, variableUrl).then(this.treatCreateResponse);

  updateItem = (item, variableUrl) =>
    this.api.updateItem(item, variableUrl).then(this.treatCurrentResponse);

  deleteItem = (id, variableUrl) =>
    this.api.deleteItem(id, variableUrl).then((res) => {
      if (res.status !== 200 && res.status !== 204) {
        throw new Error(res.data.message);
      }
    });
}
